<template>
    <div class="container-fluid form-container take-over-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Weekly Functional Test Form
                </h1>
            </div>
        </div>

        <form
            action=""
            class="weekly-functional-test"
            @submit.prevent="saveForm"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <label class="form-label">Engineer</label>
                            <user-select-component
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                                required
                            />
                        </div>
                        <div class="col">
                            <label class="form-label">Test Date</label>
                            <date-time-picker-component
                                v-model="form.test_date"
                                :options="testDatePickerOptions"
                                :disabled="!isAdmin"
                                required
                            />
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col">
                            <vehicle-select
                                v-model="form.vehicle_reg"
                                label="Vehicle Reg"
                                required
                                placeholder="Select Vehicle"
                            />
                        </div>
                        <div class="col">
                            <label class="form-label">Mileage</label>
                            <input
                                type="number"
                                min="0"
                                step="1"
                                class="form-control"
                                v-model="form.mileage"
                                required
                            >
                        </div>
                    </div>
                    <div
                        class="row mb-4"
                        v-if="form.id && isAdmin"
                    >
                        <div class="col">
                            <label class="form-label">Created</label>
                            <input
                                type="text"
                                class="form-control"
                                :value="form.created_at | datetime"
                                readonly
                            >
                        </div>
                        <div class="col">
                            <label class="form-label">Updated</label>
                            <input
                                type="text"
                                class="form-control"
                                :value="form.updated_at | datetime"
                                readonly
                            >
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <label>Is the van cleaned inside and out?</label>
                            <br>
                            <small>This Also Includes: Dashboard, Van Doors, Vans Mats, Sliding Doors</small>
                            <div>
                                <label class="form-check-label">
                                    <input
                                        type="checkbox"
                                        v-model="form.van_clean"
                                        name="van_clean"
                                        :required="!form.van_clean"
                                        true-value="Yes"
                                        class="mr-1"
                                    >
                                    Yes
                                </label>
                                <label class="form-check-label">
                                    <input
                                        type="checkbox"
                                        v-model="form.van_clean"
                                        name="van_clean"
                                        :required="!form.van_clean"
                                        true-value="No"
                                    >
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <h3>Test and Checks</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Test</th>
                                        <th class="text-center">
                                            OK
                                        </th>
                                        <th class="text-center">
                                            Fault
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="field in testFields"
                                        :key="field.key"
                                    >
                                        <td>{{ field.label }}</td>
                                        <td class="text-center">
                                            <input
                                                type="checkbox"
                                                v-model="form[field.key]"
                                                :name="field.key"
                                                :required="!form[field.key]"
                                                true-value="OK"
                                            >
                                        </td>
                                        <td class="text-center">
                                            <input
                                                type="checkbox"
                                                v-model="form[field.key]"
                                                :name="field.key"
                                                :required="!form[field.key]"
                                                true-value="Fault"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <label class="form-label">Action/Other Remarks</label>
                            <br>
                            <textarea
                                rows="10"
                                v-model="form.action_other"
                                class="w-100"
                                placeholder="Type actions required or other remarks..."
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <h3>Stock and Kit Check List</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            colspan="2"
                                            class="text-center"
                                        >
                                            Service Kit
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="kit in serviceKit"
                                        :key="kit.key"
                                    >
                                        <td>
                                            {{ kit.label }}
                                        </td>
                                        <td class="w-4">
                                            <input
                                                type="checkbox"
                                                class="form-control"
                                                v-model="form[kit.key]"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            colspan="2"
                                            class="text-center"
                                        >
                                            I.D Signs
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="sign in signChecks"
                                        :key="sign.key"
                                    >
                                        <td>
                                            {{ sign.label }}
                                        </td>
                                        <td class="w-4">
                                            <input
                                                type="checkbox"
                                                class="form-control"
                                                v-model="form[sign.key]"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            colspan="3"
                                            class="text-center"
                                        >
                                            Detection
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="detection in detectionChecks"
                                        :key="detection.key"
                                    >
                                        <td>
                                            {{ detection.label }}
                                        </td>
                                        <td class="w-4">
                                            <div class="d-flex">
                                                <input
                                                    type="checkbox"
                                                    class="form-control"
                                                    v-model="form[detection.key]"
                                                >
                                                <span>/</span>
                                                <input
                                                    type="checkbox"
                                                    class="form-control"
                                                    v-model="form[detection.key+'_alt']"
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            colspan="2"
                                            class="text-center"
                                        >
                                            Scale Calibration Record - Check List
                                        </th>
                                    </tr>
                                    <tr>
                                        <th
                                            colspan="2"
                                            class="text-center"
                                        >
                                            Required Accuracy (Accept / Reject Criteria) +/- 2%
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Equipment:</td>
                                        <td>
                                            <strong>25kg Mayer Digital Scales</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Serial / I.D. No.</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.serial_id_no"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Calibration Method:</td>
                                        <td>
                                            <strong>Internal</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 KG +/-20G</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.scale_1kg"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>5 KG +/-100G</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.scale_5kg"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>10 KG +/-200G</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.scale_10kg"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Pass / Fail</td>
                                        <td>
                                            <select
                                                v-model="form.scales_test"
                                                class="form-control"
                                            >
                                                <option>Pass</option>
                                                <option>Fail</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            colspan="2"
                                            class="text-center"
                                        >
                                            Van P.P.E
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2 x Hard Hats & 2 x Safety Glasses</td>
                                        <td>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="form.van_hard_hats"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2 x Ear Defenders & 2 x Gloves</td>
                                        <td>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="form.van_ear_defenders"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <h3>Ladder Checks</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <table>
                                <tr>
                                    <th>Ladder Identity Mark</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_id`"
                                    >
                                        <input
                                            type="text"
                                            v-model="ladder.id"
                                            class="form-control"
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <th>General: Identity mark legible</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_legible`"
                                    >
                                        <checks-select v-model="ladder.legible" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        Loose steps or rungs (considered loose if they can be moved at all with the
                                        hand)
                                    </th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_rungs`"
                                    >
                                        <checks-select v-model="ladder.loose_rungs" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Loose nails, screws, bolts or other metal parts</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_rungs`"
                                    >
                                        <checks-select v-model="ladder.loose_nails" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Cracked, split or broken uprights, braces, steps or rungs</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_cracked_rungs`"
                                    >
                                        <checks-select v-model="ladder.cracked_nails" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Slivers on uprights, rungs or steps</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_slivers`"
                                    >
                                        <checks-select v-model="ladder.slivers" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Damaged or worn non-slip bases</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_damaged_non_slip`"
                                    >
                                        <checks-select v-model="ladder.damaged_non_slip" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Stepladders: Wobbly (from side strain)</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_wobbly`"
                                    >
                                        <checks-select v-model="ladder.wobbly" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Loose or bent hinge spreaders</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_hinge`"
                                    >
                                        <checks-select v-model="ladder.loose_hinge" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Stop on hinge spreaders broken</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_hinge_stops_broken`"
                                    >
                                        <checks-select v-model="ladder.hinge_stops_broken" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Broken, split or worn steps</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_broken_steps`"
                                    >
                                        <checks-select v-model="ladder.broken_steps" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Loose hinges</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_hinges`"
                                    >
                                        <checks-select v-model="ladder.loose_hinges" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Extension ladders: Loose, broken or missing extension locks</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_extension_locks`"
                                    >
                                        <checks-select v-model="ladder.loose_extension_locks" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Defective locks that do not seat properly when the ladder is extended</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_defective_locks`"
                                    >
                                        <checks-select v-model="ladder.defective_locks" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Deterioration of rope from exposure to weather or other destructive agents</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_deteriorated_rope`"
                                    >
                                        <checks-select v-model="ladder.deteriorated_rope" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Trestle ladders: Loose hinges</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_hinges`"
                                    >
                                        <checks-select v-model="ladder.loose_hinges" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Wobbly</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_wobbly_trestle`"
                                    >
                                        <checks-select v-model="ladder.wobbly_trestle" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Loose or bent hinge spreaders</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_loose_trestle_hinges`"
                                    >
                                        <checks-select v-model="ladder.loose_trestle_hinges" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Stop or hinge spreader broken</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_broken_trestle_hinges`"
                                    >
                                        <checks-select v-model="ladder.broken_trestle_hinges" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Centre section guide for extension out of alignment</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_center_out_alignment`"
                                    >
                                        <checks-select v-model="ladder.center_out_alignment" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Defective locks for extension</th>
                                    <td
                                        v-for="(ladder, index) in form.ladders"
                                        :key="`ladder_${index}_defective_locks`"
                                    >
                                        <checks-select v-model="ladder.defective_locks" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    v-model="form.confirm"
                                    required
                                    class="mr-2"
                                >
                                <span>I confirm that the above checks have been carried out</span>
                            </label>
                        </div>
                        <div class="col text-right">
                            <button class="btn-primary btn">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import DateTimePickerComponent from '../DateTimePickerComponent.vue';
import UserSelectComponent from '../UserSelectComponent.vue';
import VehicleSelect from '../VehicleSelectComponent.vue';
import ChecksSelect from './parts/ChecksSelectComponent.vue';
import FormService from "../../services/FormService";
import AuthService from "../../services/AuthService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";

const defaultForm = {
    vehicle_reg: '',
    test_date: window.moment(),
    ladders: [
        {},
        {},
        {},
        {},
        {},
    ],
};

export default {
    components: {
        UserSelectComponent,
        DateTimePickerComponent,
        VehicleSelect,
        ChecksSelect,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    data() {
        return {
            form: {...defaultForm},
            loading: false,
            saving: false,
            testDateMaxDate: window.moment().endOf('day'),
            testFields: [
                {
                    label: 'Headlights and rear lights',
                    key: 'headlights',
                },
                {
                    label: 'Indicators and reg bulbs',
                    key: 'inidicators',
                },
                {
                    label: 'Dashboard',
                    key: 'dashboard',
                },
                {
                    label: 'Engine oli checked',
                    key: 'engine_oil',
                },
                {
                    label: 'Engine water level',
                    key: 'engine_water',
                },
                {
                    label: 'Screen wash bottle',
                    key: 'screen_wash',
                },
                {
                    label: 'Wiper blades in working order',
                    key: 'wiper_blade',
                },
                {
                    label: 'Mirrors',
                    key: 'mirrors',
                },
                {
                    label: 'Seats and seatbelts',
                    key: 'seats',
                },
                {
                    label: 'Horn',
                    key: 'horn',
                },
                {
                    label: 'Tyres',
                    key: 'tyres',
                },
                {
                    label: 'Spare tyre / jack and wheel brace',
                    key: 'spare_tyre',
                },
                {
                    label: 'Repairs due',
                    key: 'repairs_due',
                },
            ],
            serviceKit: [
                {
                    label: 'Tamper tags',
                    key: 'tamper_tags'
                },
                {
                    label: 'Gauge tester',
                    key: 'gauge_tester'
                },
                {
                    label: 'Gauge dots',
                    key: 'gauge_dots'
                },
                {
                    label: 'O-ring box - full',
                    key: 'o_ring_box'
                },
                {
                    label: 'O-ring remover',
                    key: 'o_ring_remover'
                },
                {
                    label: 'Spare Pins',
                    key: 'spare_pins'
                },
                {
                    label: 'Adjustable wrench',
                    key: 'adjustable_wrench'
                },
                {
                    label: 'Service Labels',
                    key: 'service_labels'
                },
                {
                    label: 'Rags',
                    key: 'rags'
                },
            ],
            signChecks: [
                {
                    label: 'CO2 I.D Sign',
                    key: 'co2_sign'
                },
                {
                    label: 'Foam I.D Sign',
                    key: 'foam_sign'
                },
                {
                    label: 'Powder I.D Sign',
                    key: 'powder_sign'
                },
                {
                    label: 'Water I.D Sign',
                    key: 'water_sign'
                },
                {
                    label: 'Wet Chemical I.D Sign',
                    key: 'wet_chem_sign'
                },
                {
                    label: 'Fire Blanket I.D Sign',
                    key: 'fire_blanket_sign'
                },
                {
                    label: 'Call Point I.D Sign',
                    key: 'call_point_sign'
                },
            ],
            detectionChecks: [
                {
                    label: 'S65 - Smoke / Heat',
                    key: 's65_smoke_heat',
                },
                {
                    label: 'Conv - MCP / Bases',
                    key: 'conv_mcp_bases',
                },
                {
                    label: 'XP95 - Smoke/Heat',
                    key: 'xp95_smoke_heat',
                },
                {
                    label: 'XP95 - MCP/Bases',
                    key: 'xp95_mcp_bases',
                },
                {
                    label: 'Fike Smoke / MCP',
                    key: 'fike_smoke_mcp',
                },
                {
                    label: 'Sounder & Srd Beacon',
                    key: 'sounder_beacon',
                },
                {
                    label: 'Hockiki Smoke & Heat',
                    key: 'hockiki_smoke_heat',
                },
                {
                    label: 'Hockiki Bases / MCP',
                    key: 'hockiki_bases',
                },
                {
                    label: 'Alarmsense Smoke / Hf',
                    key: 'alarmsense_smoke_hf',
                },
            ],
            paperWorkChecks: [
                {
                    label: 'Invoices',
                    key: 'invoices',
                },
                {
                    label: 'Dockets',
                    key: 'dockets',
                },
                {
                    label: 'Blank 10 Year Planner',
                    key: '10_year_planner',
                },
                {
                    label: 'Quotation & Recommendation\'s',
                    key: 'quotation_recommendation',
                },
                {
                    label: 'Fire Alarm & Emergency Lighting Form',
                    key: 'fire_alarm_e_lighting',
                },
                {
                    label: 'Sorry We Missed You Cards',
                    key: 'missed_you_cards',
                },
                {
                    label: 'Everlux Sign Books',
                    key: 'everlux_sign_books',
                },
                {
                    label: 'Business Cards',
                    key: 'business_cards',
                },
                {
                    label: 'Backing Board',
                    key: 'backing_board',
                },
                {
                    label: 'Fire Log Books',
                    key: 'fire_log_books',
                },
            ],
        };
    },
    computed: {
        isAdmin() {
            return AuthService.user && AuthService.user.admin_access;
        },
        testDatePickerOptions() {
            const options = {
                format: 'L',
            };
            if (this.isAdmin) {
                options.maxDate = this.testDateMaxDate;
            }
            return options;
        },
    },
    watch: {
        $route: {
            handler: function () {
                this.loadForm();
            },
            immediate: true,
        }
    },
    methods: {
        saveForm() {
            this.clearErrors();
            this.saving = true;
            const formData = {
                ...this.form,
                type: 'weekly_functional_test',
                test_date: this.form.test_date
                    ? window.moment(this.form.test_date).format('YYYY-MM-DD')
                    : window.moment().format('YYYY-MM-DD'),
            };
            FormService.save(formData).then(({data}) => {
                this.setInfoMessage("Form saved successfully");
                const ladders = data.ladders
                    ? data.ladders.map((ladder) => ladder instanceof Array ? {} : ladder)
                    : this.form.ladders;
                this.form = {
                    ...data,
                    ladders,
                    test_date: data.test_date ? window.moment(data.test_date) : window.moment(),
                };
                if (!this.$route.params.id) {
                    if (this.$route.path.includes("engineer/")) {
                        this.$router.push({
                            name: "engineer.forms.edit",
                            params: {
                                id: data.id
                            }
                        });
                    } else {
                        this.$router.push({
                            name: "office.forms.edit",
                            params: {
                                id: data.id
                            }
                        });
                    }
                }
            }).catch(err => {
                this.captureRequestErrors(err);
            }).finally(() => {
                this.saving = true;
            });
        },
        loadForm() {
            this.loading = true;
            const id = this.$route.params.id;
            if (!id) {
                this.form = {...defaultForm};
                this.loading = false;
                return;
            }
            FormService.get(id).then(({data}) => {
                const ladders = data.ladders.map((ladder) => ladder instanceof Array ? {} : ladder)

                this.form = {
                    ...data,
                    ladders,
                    test_date: data.test_date ? window.moment(data.test_date) : window.moment(),
                };
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.$router.back();
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/WeeklyFunctionalTest.vue